var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          staticClass: "ml-2",
          attrs: { size: "sm", variant: "primary" },
          on: { click: _vm.openModal },
        },
        [
          _c("i", { class: ["icon", "inticon-edit"] }),
          _vm._v("\n        " + _vm._s(_vm.buttonText) + "\n    "),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            title: "Aktualisierung der Daten anfragen",
          },
          on: { hide: _vm.reset },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "div",
            { staticClass: "info-card editMode loading-content-container" },
            [
              _vm.isLoading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "loading-overlay d-flex justify-content-center pt-5",
                    },
                    [_c("csp-loading-indicator")],
                    1
                  )
                : _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("csp-form-group-textarea", {
                        staticClass: "info-card-element",
                        attrs: {
                          form: _vm.form,
                          "override-label": _vm.fieldLabel,
                          property: "retroactiveChangesNote",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { disabled: _vm.isLoading, type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n                        An Verantwortlichen senden\n                    "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }